export default __webpack_public_path__ + "media/images/clients-01-150x134-e8a6229737f5d509c1e371942519c509.png";